import './styles.scss';
import VisaLogo from 'lib.assets/src/cards/Visa';
import MasterCardLogo from 'lib.assets/src/cards/MasterCard';

export const IsDefaultPlug = ({
  isDefaultSubdued,
  isSelectPlug,
}: {
  isDefaultSubdued?: boolean;
  isSelectPlug?: boolean;
}) => {
  return (
    <span
      className={
        isDefaultSubdued
          ? 'text-subdued'
          : isSelectPlug
            ? 'default-payment-plug'
            : 'billing-default-payment-plug'
      }
    >
      Default
    </span>
  );
};

export const CardLogo = ({ brand }: { brand: string }) => {
  switch (brand) {
    case 'mastercard':
      return (
        <div className="balance-card__card-logo">
          <MasterCardLogo />
        </div>
      );
    case 'visa':
      return (
        <div className="balance-card__card-logo">
          <VisaLogo />
        </div>
      );
    default:
      return <></>;
  }
};

type Props = {
  brand: string;
  last4: string;
  isDefault?: boolean;
  isDefaultSubdued?: boolean;
  isSelectPlug?: boolean;
};

const BrandedCardItem = ({ brand, last4, isDefault, isDefaultSubdued, isSelectPlug }: Props) => {
  return (
    <div className="billing-page-content__payment-method__row-method">
      <CardLogo brand={brand} />
      <span className="mx-6">ending in {last4}</span>
      {isDefault && (
        <IsDefaultPlug isDefaultSubdued={isDefaultSubdued} isSelectPlug={isSelectPlug} />
      )}
    </div>
  );
};

export default BrandedCardItem;
